import { useState } from "react";
import { Loader2, Stamp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { MANUAL_CONFIRMATION } from "@/constants/testIds";

// Diálogo genérico para que el admin marque un acuse de política o un documento de firma como
// "confirmado/firmado manualmente" (empleados sin acceso al portal) — sin foto ni archivo, solo
// una nota de texto libre opcional. Usado tanto en el expediente (políticas) como en la
// Biblioteca de Documentos (firma física).
export function ManualConfirmDialog({ triggerTestId, triggerLabel, title, description, onConfirm }) {
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await onConfirm(note);
      setOpen(false);
      setNote("");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button data-testid={triggerTestId} size="sm" variant="outline" className="rounded-full border-petroleum/30 text-petroleum">
          <Stamp className="w-4 h-4 mr-1" /> {triggerLabel}
        </Button>
      </DialogTrigger>
      <DialogContent data-testid={MANUAL_CONFIRMATION.dialog} className="bg-bone">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <Textarea
          data-testid={MANUAL_CONFIRMATION.noteInput}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder='Nota opcional (ej. "Firmado en papel, está en su expediente físico")'
          rows={3}
          className="bg-white"
        />
        <Button data-testid={MANUAL_CONFIRMATION.submitButton} onClick={submit} disabled={busy} className="w-full bg-petroleum rounded-full">
          {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : null} Confirmar
        </Button>
      </DialogContent>
    </Dialog>
  );
}
